export function track(name: string, value: string) {
	window.plausible?.(name, { props: { section: value } })
	window.dataLayer?.push({ [name]: value })
}
